/**
 * Archivo: ToggleButton.js
 * Autor: Acher Egido Mairal
 * Fecha de última modificación: 2024-07-10
 * 
 * Descripción:
 * Este componente define un botón de alternancia (toggle button) que cambia de estado entre "SI" y "NO" al hacer clic.
 * 
 * Dependencias:
 * - react: ^18.2.0
 * 
 * Propósito:
 * Proporcionar un botón de alternancia visualmente atractivo y funcional que se puede usar en diferentes partes de la aplicación.
 */

import React, { Component } from "react";
import "../Estilos/botones.css";

export class ToggleButton extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { selected, toggleSelected } = this.props;
    return (
      <div className="toggle-container" onClick={toggleSelected}>
        <div className={`dialog-button ${selected ? "" : "disabled"}`}>
          {selected ? "SI" : "NO"}
        </div>
      </div>
    );
  }
}
